import { graphql, useStaticQuery } from "gatsby";
import { useLanguage } from "../../utils/localization/languages/I18nContext";
import { StaticGrandVoyagesDataQuery } from "types/graphql-types";
import {
  LocalizedStaticQueryResult,
  localizeStaticQuery
} from "./localizeStaticQuery";

const useStaticGrandVoyagesData = (): LocalizedStaticQueryResult<
  StaticGrandVoyagesDataQuery["cruises"]["nodes"][0]
>[] => {
  const language = useLanguage();
  const { cruises } = useStaticQuery<StaticGrandVoyagesDataQuery>(
    graphql`
      query StaticGrandVoyagesData {
        cruises: allSanitySpecialVoyage(
          filter: {
            isVisible: { eq: true }
            data: { comboType: { eq: "Grand" } }
            metadata: { routing: { slug: { en: { current: { ne: null } } } } }
          }
          sort: { fields: data___departureDate, order: DESC }
        ) {
          nodes {
            _id
            id
            isVisible
            fullPath
            i18nFullPaths
            metadata {
              tracking {
                name
              }
            }
            card {
              ...AsCardForStaticQuery
            }
          }
        }
      }
    `
  );

  const ensureOnlyVisibleCruises = cruises.nodes.filter((n) => n.isVisible); //for some reasons, gatsby sometimes shows non visible cruises
  return localizeStaticQuery(ensureOnlyVisibleCruises, language);
};

export default useStaticGrandVoyagesData;
